<template>
	<c-dialog ref="dialog" width="1000" height="560" enable-flex>
		<!-- 结果汇总：提交成功数与未上架数同屏，明细逐条给原因 -->
		<div class="m-result-summary flex">
			<p class="flex-grow">
				<span class="m-count-success">提交成功 {{successCount}}个商品</span>
				<span v-if="failCount" class="m-count-fail">，{{failCount}}项未上架</span>
			</p>
			<p v-if="failCount > failList.length" class="m-count-limit">仅展示前{{failList.length}}项</p>
		</div>

		<div class="m-result-table-area flex-column flex-grow">
			<c-table ref="list" :data="failList" height="grow" :paging="false" empty-text="没有未上架的记录">
				<c-table-column label="背贴码" name="produce_unique_code" width="90"></c-table-column>
				<c-table-column label="商品信息" name="product_info" min-width="200"></c-table-column>
				<c-table-column label="渠道" min-width="90">
					<template #default="{data}">{{data.channel_name || '全部渠道'}}</template>
				</c-table-column>
				<c-table-column label="未上架原因" min-width="180">
					<template #default="{data}"><span class="m-reason">{{data.reason}}</span></template>
				</c-table-column>
			</c-table>
		</div>

		<!-- 置位成功不等于渠道已上架，最终态由消费项目/定时任务回写，此处把异步口径讲明白 -->
		<div class="m-result-tip">已提交系统自动上架，稍后刷新列表查看结果；暗拍渠道由系统统一定时处理</div>

		<template #button>
			<c-button size="dialog" color="main" @click="$refs.dialog.close()">知道了</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleBatchShelfResult',

		data() {
			return {
				successCount: 0,
				/**后端返回的未上架总项数，可能大于已回传明细数（受回传上限约束）*/
				failCount: 0,
				failList: []
			}
		},

		methods: {
			/*********打开弹框（只读结果页，入参为 batchOnShelf 返回的统计对象）**********/
			open(data) {
				var result = data || {};
				this.successCount = result.success_count || 0;
				this.failCount = result.fail_count || 0;
				this.failList = result.fail_list || [];
				this.$refs.dialog.open({
					title: '批量上架结果'
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	::v-deep .c-dialog-body {
		padding: 0 12px;
	}

	.m-result-summary {
		padding: 12px 15px;
		margin-bottom: 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 14px;
		gap: 12px;

		.m-count-success {
			color: #19be6b;
		}

		.m-count-fail {
			color: #ed3f14;
		}

		.m-count-limit {
			color: #909399;
			font-size: 13px;
		}
	}

	.m-result-table-area {
		margin: 0 20px 10px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;

		.m-reason {
			color: #ed3f14;
		}
	}

	.m-result-tip {
		padding: 0 20px 12px;
		font-size: 13px;
		color: #909399;
	}
</style>
